/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type CalendarQueryVariables = {
    handle: string;
    includeArchived?: string | null;
    viewType?: string | null;
    year?: number | null;
    month?: number | null;
};
export type CalendarQueryResponse = {
    readonly calendarQuery: {
        readonly calendarEvents: ReadonlyArray<{
            readonly date: string;
            readonly shipmentTotal: number;
            readonly containerTotal: number;
            readonly categories: {
                readonly dc: {
                    readonly count: number;
                } | null;
                readonly cc: {
                    readonly count: number;
                } | null;
                readonly billing: {
                    readonly count: number;
                } | null;
                readonly done: {
                    readonly count: number;
                } | null;
                readonly confirmed: {
                    readonly count: number;
                } | null;
                readonly releaseRequested: {
                    readonly count: number;
                } | null;
                readonly releaseConfirmed: {
                    readonly count: number;
                } | null;
                readonly pickupSent: {
                    readonly count: number;
                } | null;
                readonly finished: {
                    readonly count: number;
                } | null;
            };
        }>;
        readonly financials: {
            readonly unpaidCount: number;
            readonly unpaidAmount: number;
        };
        readonly categoryChart: ReadonlyArray<{
            readonly month: string;
            readonly categories: any;
        }>;
    } | null;
};
export type CalendarQuery = {
    readonly response: CalendarQueryResponse;
    readonly variables: CalendarQueryVariables;
};



/*
query CalendarQuery(
  $handle: String!
  $includeArchived: String
  $viewType: String
  $year: Int
  $month: Int
) {
  calendarQuery(handle: $handle, includeArchived: $includeArchived, viewType: $viewType, year: $year, month: $month) {
    calendarEvents {
      date
      shipmentTotal
      containerTotal
      categories {
        dc {
          count
        }
        cc {
          count
        }
        billing {
          count
        }
        done {
          count
        }
        confirmed {
          count
        }
        releaseRequested {
          count
        }
        releaseConfirmed {
          count
        }
        pickupSent {
          count
        }
        finished {
          count
        }
      }
    }
    financials {
      unpaidCount
      unpaidAmount
    }
    categoryChart {
      month
      categories
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "handle"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeArchived"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "year"
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "handle",
        "variableName": "handle"
      },
      {
        "kind": "Variable",
        "name": "includeArchived",
        "variableName": "includeArchived"
      },
      {
        "kind": "Variable",
        "name": "month",
        "variableName": "month"
      },
      {
        "kind": "Variable",
        "name": "viewType",
        "variableName": "viewType"
      },
      {
        "kind": "Variable",
        "name": "year",
        "variableName": "year"
      }
    ],
    "concreteType": "Calendar",
    "kind": "LinkedField",
    "name": "calendarQuery",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CalendarEvent",
        "kind": "LinkedField",
        "name": "calendarEvents",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shipmentTotal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "containerTotal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarEventCategories",
            "kind": "LinkedField",
            "name": "categories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryCount",
                "kind": "LinkedField",
                "name": "dc",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryCount",
                "kind": "LinkedField",
                "name": "cc",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryCount",
                "kind": "LinkedField",
                "name": "billing",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryCount",
                "kind": "LinkedField",
                "name": "done",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryCount",
                "kind": "LinkedField",
                "name": "confirmed",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryCount",
                "kind": "LinkedField",
                "name": "releaseRequested",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryCount",
                "kind": "LinkedField",
                "name": "releaseConfirmed",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryCount",
                "kind": "LinkedField",
                "name": "pickupSent",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CategoryCount",
                "kind": "LinkedField",
                "name": "finished",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FinancialsData",
        "kind": "LinkedField",
        "name": "financials",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unpaidCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unpaidAmount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CategoryChartMonth",
        "kind": "LinkedField",
        "name": "categoryChart",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "month",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categories",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarQuery",
    "selections": (v6/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CalendarQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "0c2224b2ab22b4279f95bbf9c63d04e8",
    "id": null,
    "metadata": {},
    "name": "CalendarQuery",
    "operationKind": "query",
    "text": "query CalendarQuery(\n  $handle: String!\n  $includeArchived: String\n  $viewType: String\n  $year: Int\n  $month: Int\n) {\n  calendarQuery(handle: $handle, includeArchived: $includeArchived, viewType: $viewType, year: $year, month: $month) {\n    calendarEvents {\n      date\n      shipmentTotal\n      containerTotal\n      categories {\n        dc {\n          count\n        }\n        cc {\n          count\n        }\n        billing {\n          count\n        }\n        done {\n          count\n        }\n        confirmed {\n          count\n        }\n        releaseRequested {\n          count\n        }\n        releaseConfirmed {\n          count\n        }\n        pickupSent {\n          count\n        }\n        finished {\n          count\n        }\n      }\n    }\n    financials {\n      unpaidCount\n      unpaidAmount\n    }\n    categoryChart {\n      month\n      categories\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '19fc7b07267e43b5ab501649a209a2b4';
export default node;
